/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptPersonTransferRequest } from '../models/AcceptPersonTransferRequest';
import type { AddGuardianRequest } from '../models/AddGuardianRequest';
import type { AddGuardianResponse } from '../models/AddGuardianResponse';
import type { AddWardRequest } from '../models/AddWardRequest';
import type { AddWardResponse } from '../models/AddWardResponse';
import type { Countries } from '../models/Countries';
import type { CreateAnonymousPersonRequest } from '../models/CreateAnonymousPersonRequest';
import type { CreatePersonRequest } from '../models/CreatePersonRequest';
import type { CreatePersonResponse } from '../models/CreatePersonResponse';
import type { CreatePersonTransferRequest } from '../models/CreatePersonTransferRequest';
import type { CreatePersonUserAssignmentRequest } from '../models/CreatePersonUserAssignmentRequest';
import type { Gender } from '../models/Gender';
import type { GetAnonymousPersonListResponse } from '../models/GetAnonymousPersonListResponse';
import type { GetGuardianshipListResponse } from '../models/GetGuardianshipListResponse';
import type { GetGuardianshipResponse } from '../models/GetGuardianshipResponse';
import type { GetInstitutionPersonListResponse } from '../models/GetInstitutionPersonListResponse';
import type { GetInstitutionPersonsPatientsListResponse } from '../models/GetInstitutionPersonsPatientsListResponse';
import type { GetPendingCountTransferRequestResponse } from '../models/GetPendingCountTransferRequestResponse';
import type { GetPersonByIdnpResponse } from '../models/GetPersonByIdnpResponse';
import type { GetPersonByIdResponse } from '../models/GetPersonByIdResponse';
import type { GetPersonListByDataResponse } from '../models/GetPersonListByDataResponse';
import type { GetPersonListResponse } from '../models/GetPersonListResponse';
import type { GetPersonPermissionsResponse } from '../models/GetPersonPermissionsResponse';
import type { GetPersonResponse } from '../models/GetPersonResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { NotifyNewCaseRequest } from '../models/NotifyNewCaseRequest';
import type { NotifyNewCaseResponse } from '../models/NotifyNewCaseResponse';
import type { PersonAssignedUsersPagedList } from '../models/PersonAssignedUsersPagedList';
import type { PersonCaseStatus } from '../models/PersonCaseStatus';
import type { PersonInstitutionsHistoryPagedList } from '../models/PersonInstitutionsHistoryPagedList';
import type { PersonInstitutionsHistorySortBy } from '../models/PersonInstitutionsHistorySortBy';
import type { PersonTransferRequestPagedList } from '../models/PersonTransferRequestPagedList';
import type { PersonTransferRequestSortBy } from '../models/PersonTransferRequestSortBy';
import type { PersonTransferRequestStatus } from '../models/PersonTransferRequestStatus';
import type { RejectPersonTransferRequest } from '../models/RejectPersonTransferRequest';
import type { UpdateGuardianshipMediaFilesRequest } from '../models/UpdateGuardianshipMediaFilesRequest';
import type { UpdateGuardianshipStatusRequest } from '../models/UpdateGuardianshipStatusRequest';
import type { UpdatePersonMediaFilesRequest } from '../models/UpdatePersonMediaFilesRequest';
import type { UpdatePersonRequest } from '../models/UpdatePersonRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PersonsService {
    /**
     * Get the list of users (doctors) assigned to the person.
     * All users (doctors) assigned to the person can access
     * personal information about the person.
     * @param personId
     * @param userId
     * @param pageNumber
     * @param pageSize
     * @returns PersonAssignedUsersPagedList The list of users assigned to person.
     * @throws ApiError
     */
    public static getListPersonUserAssignmentsEndpoint(
        personId: string,
        userId?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<PersonAssignedUsersPagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/user-assignments',
            path: {
                'personId': personId,
            },
            query: {
                'userId': userId,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Assigning a user (doctor) to the person.
     * Assigning a user (doctor) to the person.
     * @param personId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createPersonUserAssignmentEndpoint(
        personId: string,
        requestBody: CreatePersonUserAssignmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/{personId}/user-assignments',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The person has not been found.`,
            },
        });
    }
    /**
     * Deletes a user (doctor) assignment from the person.
     * Deletes a user (doctor) assignment from the person.
     * @param personId
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static deletePersonUserAssignmentEndpoint(
        personId: string,
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/persons/{personId}/user-assignments/{userId}',
            path: {
                'personId': personId,
                'userId': userId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update person media files.
     * This endpoint allows to update media files associated with a specific Person.
     * You must specify the `PersonId` and provide a list of media file IDs under `MediaItems`.
     * The `PersonId` should be a valid GUID, and each `MediaItem` ID must also be a valid GUID.
     * @param personId
     * @param requestBody
     * @returns any Successfully added media files for the person.
     * @throws ApiError
     */
    public static updatePersonMediaFilesEndpoint(
        personId: string,
        requestBody: UpdatePersonMediaFilesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/{personId}/media-files',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided, are invalid, or conflict with existing records.`,
                401: `The user is not authorized to perform this action.`,
            },
        });
    }
    /**
     * Reject a person transfer request.
     * This endpoint requires the following permissions: [ Persons.TransferRequest.Manage.Institution ]
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectPersonTransferRequestEndpoint(
        id: string,
        requestBody: RejectPersonTransferRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/transfer-requests/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The transfer request has not been found.`,
            },
        });
    }
    /**
     * Get pending transfer requests count for current user institution.
     * This endpoint requires the following permissions: [ Persons.TransferRequest.View.Institution ]
     * @returns GetPendingCountTransferRequestResponse The count of pending person transfer requests.
     * @throws ApiError
     */
    public static getPendingCountTransferRequestEndpoint(): CancelablePromise<GetPendingCountTransferRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/transfer-requests/pending-count',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get paginated list of person transfer requests.
     * This endpoint requires the following permissions: [ Persons.TransferRequest.View.Institution ]
     * @param pageNumber
     * @param pageSize
     * @param searchTerm
     * @param sortDirection
     * @param sortBy
     * @param status
     * @param personId
     * @param institutionId
     * @param sourceInstitutionId
     * @param destinationInstitutionId
     * @param createdAtFrom
     * @param createdAtTo
     * @param personGender
     * @param personBirthDateFrom
     * @param personBirthDateTo
     * @returns PersonTransferRequestPagedList The paginated list of transfer requests.
     * @throws ApiError
     */
    public static getListPersonTransferRequestEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        sortBy?: PersonTransferRequestSortBy | null,
        status?: PersonTransferRequestStatus | null,
        personId?: string | null,
        institutionId?: string | null,
        sourceInstitutionId?: string | null,
        destinationInstitutionId?: string | null,
        createdAtFrom?: string | null,
        createdAtTo?: string | null,
        personGender?: Gender | null,
        personBirthDateFrom?: string | null,
        personBirthDateTo?: string | null,
    ): CancelablePromise<PersonTransferRequestPagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/transfer-requests/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'status': status,
                'personId': personId,
                'institutionId': institutionId,
                'sourceInstitutionId': sourceInstitutionId,
                'destinationInstitutionId': destinationInstitutionId,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'personGender': personGender,
                'personBirthDateFrom': personBirthDateFrom,
                'personBirthDateTo': personBirthDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Create a person transfer request.
     * This endpoint requires the following permissions: [ Persons.TransferRequest.Create.Institution ]
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createPersonTransferRequestEndpoint(
        requestBody: CreatePersonTransferRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/transfer-requests/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The person has not been found.`,
            },
        });
    }
    /**
     * Accept a person transfer request.
     * This endpoint requires the following permissions: [ Persons.TransferRequest.Manage.Institution ]
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static acceptPersonTransferRequestEndpoint(
        id: string,
        requestBody: AcceptPersonTransferRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/transfer-requests/{id}/accept',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The transfer request has not been found.`,
            },
        });
    }
    /**
     * Checks if the user has access to full person data.
     * This endpoint verifies whether the user is authorized to view full details of a person.
     * @param personId
     * @returns GetPersonPermissionsResponse The access status for the requested person.
     * @throws ApiError
     */
    public static getPersonPermissionsEndpoint(
        personId: string,
    ): CancelablePromise<GetPersonPermissionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/person/{personId}/permissions',
            path: {
                'personId': personId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the list of person institutions history.
     * Get the list of person institutions history.
     * @param personId
     * @param pageNumber
     * @param pageSize
     * @param sortDirection
     * @param sortBy
     * @param institutionId
     * @param startDateFrom
     * @param startDateTo
     * @param endDateFrom
     * @param endDateTo
     * @returns PersonInstitutionsHistoryPagedList The paginated list of items.
     * @throws ApiError
     */
    public static getListPersonInstitutionsHistoryEndpoint(
        personId: string,
        pageNumber: number = 1,
        pageSize: number = 10,
        sortDirection?: ListSortDirection | null,
        sortBy?: PersonInstitutionsHistorySortBy | null,
        institutionId?: string | null,
        startDateFrom?: string | null,
        startDateTo?: string | null,
        endDateFrom?: string | null,
        endDateTo?: string | null,
    ): CancelablePromise<PersonInstitutionsHistoryPagedList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/institutions-history',
            path: {
                'personId': personId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'sortDirection': sortDirection,
                'sortBy': sortBy,
                'institutionId': institutionId,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'endDateFrom': endDateFrom,
                'endDateTo': endDateTo,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Search for persons in the system by detailed criteria.
     * Search for persons using specific criteria:
     * - **FirstName**: Filter by the person's first name (case-insensitive, minimum 3 characters).
     * - **LastName**: Filter by the person's last name (case-insensitive, minimum 3 characters).
     * - **Gender**: Filter by gender (e.g., Male, Female, Other).
     * - **BirthDate**: Filter by the person's date of birth.
     * @param shouldSearchInMConnect
     * @param idnp
     * @param testrapCode
     * @param firstName
     * @param lastName
     * @param gender
     * @param citizenship
     * @param birthDate
     * @param birthDateFrom
     * @param birthDateTo
     * @param localityId
     * @param includePatients
     * @returns GetPersonListByDataResponse List of persons matching the criteria.
     * @throws ApiError
     */
    public static getPersonListByDataEndpoint(
        shouldSearchInMConnect: boolean,
        idnp?: string | null,
        testrapCode?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        gender?: Gender | null,
        citizenship?: Countries | null,
        birthDate?: string | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        localityId?: string | null,
        includePatients?: boolean | null,
    ): CancelablePromise<GetPersonListByDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/by-data',
            query: {
                'idnp': idnp,
                'testrapCode': testrapCode,
                'firstName': firstName,
                'lastName': lastName,
                'gender': gender,
                'citizenship': citizenship,
                'shouldSearchInMConnect': shouldSearchInMConnect,
                'birthDate': birthDate,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'localityId': localityId,
                'includePatients': includePatients,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `User is not allowed to search.`,
                404: `A person with this Idnp not found.`,
            },
        });
    }
    /**
     * @deprecated
     * Search and retrieve a list of persons in the system
     *
     * Search for persons in the system with advanced filtering and sorting options:
     * - **Gender**: Filter results by gender (e.g., Male, Female, -).
     * - **BirthDateFrom**: Include persons born on or after this date.
     * - **BirthDateTo**: Include persons born on or before this date.
     * - **MonitoringFilter**:
     * - `None`: Search all persons.
     * - `Institution`: Filter by the monitoring institution linked to the current user.
     * - `InstitutionUserAssignment`: Filter by the monitoring institution and check if the user is assigned.
     * - **SearchTerm**: Filter by SimeCode, TarvCode, IDNP, FirstName, or LastName.
     * - **SortBy**: Specify the field to sort results by (e.g., SimeCode, TarvCode, IDNP, FirstName, LastName).
     * - **SortDirection**: Indicate sorting order.
     * - **PageNumber**: Specify the page number for pagination (default: 1).
     * - **PageSize**: Specify the number of records per page (default: 10, maximum: 100).
     *
     * @param pageNumber
     * @param pageSize
     * @param gender
     * @param birthDateFrom
     * @param birthDateTo
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param includeAnonymous
     * @param includePatients
     * @param hasActiveRiskGroup
     * @param caseStatuses
     * @returns GetPersonListResponse The list has been found.
     * @throws ApiError
     */
    public static getPersonListEndpoint(
        pageNumber: number,
        pageSize: number,
        gender?: Gender | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        includeAnonymous?: boolean | null,
        includePatients?: boolean | null,
        hasActiveRiskGroup?: boolean | null,
        caseStatuses?: Array<PersonCaseStatus> | null,
    ): CancelablePromise<GetPersonListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'gender': gender,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'includeAnonymous': includeAnonymous,
                'includePatients': includePatients,
                'hasActiveRiskGroup': hasActiveRiskGroup,
                'caseStatuses': caseStatuses,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Add a person in system.
     * Add a person to the system using the CreatePersonEndpoint.
     * @param requestBody
     * @returns CreatePersonResponse Successfully created the person.
     * @throws ApiError
     */
    public static createPersonEndpoint(
        requestBody: CreatePersonRequest,
    ): CancelablePromise<CreatePersonResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
                409: `A person with this IDNP already exists.`,
            },
        });
    }
    /**
     * Search and retrieve a list of persons that are patients for current user and institution
     *
     * Search for persons patients in the system with advanced filtering and sorting options:
     * - **Gender**: Filter results by gender (e.g., Male, Female, -).
     * - **BirthDateFrom**: Include persons born on or after this date.
     * - **BirthDateTo**: Include persons born on or before this date.
     * - **SearchTerm**: Filter by SimeCode, TarvCode, IDNP, FirstName, or LastName.
     * - **SortBy**: Specify the field to sort results by (e.g., SimeCode, TarvCode, IDNP, FirstName, LastName).
     * - **SortDirection**: Indicate sorting order.
     * - **PageNumber**: Specify the page number for pagination (default: 1).
     * - **PageSize**: Specify the number of records per page (default: 10, maximum: 100).
     *
     * @param pageNumber
     * @param pageSize
     * @param gender
     * @param birthDateFrom
     * @param birthDateTo
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param includeAnonymous
     * @param includePatients
     * @param hasActiveRiskGroup
     * @param caseStatuses
     * @returns GetInstitutionPersonsPatientsListResponse The list has been found.
     * @throws ApiError
     */
    public static getInstitutionPersonsPatientsListEndpoint(
        pageNumber: number,
        pageSize: number,
        gender?: Gender | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        includeAnonymous?: boolean | null,
        includePatients?: boolean | null,
        hasActiveRiskGroup?: boolean | null,
        caseStatuses?: Array<PersonCaseStatus> | null,
    ): CancelablePromise<GetInstitutionPersonsPatientsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institution/persons/patients',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'gender': gender,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'includeAnonymous': includeAnonymous,
                'includePatients': includePatients,
                'hasActiveRiskGroup': hasActiveRiskGroup,
                'caseStatuses': caseStatuses,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Search and retrieve a list of persons in the system
     *
     * Search for persons in the system with advanced filtering and sorting options:
     * - **Gender**: Filter results by gender (e.g., Male, Female, -).
     * - **BirthDateFrom**: Include persons born on or after this date.
     * - **BirthDateTo**: Include persons born on or before this date.
     * - **SearchTerm**: Filter by SimeCode, TarvCode, IDNP, FirstName, or LastName.
     * - **SortBy**: Specify the field to sort results by (e.g., SimeCode, TarvCode, IDNP, FirstName, LastName).
     * - **SortDirection**: Indicate sorting order.
     * - **PageNumber**: Specify the page number for pagination (default: 1).
     * - **PageSize**: Specify the number of records per page (default: 10, maximum: 100).
     *
     * @param pageNumber
     * @param pageSize
     * @param gender
     * @param birthDateFrom
     * @param birthDateTo
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param includeAnonymous
     * @param includePatients
     * @param hasActiveRiskGroup
     * @param caseStatuses
     * @returns GetInstitutionPersonListResponse The list has been found.
     * @throws ApiError
     */
    public static getInstitutionPersonListEndpoint(
        pageNumber: number,
        pageSize: number,
        gender?: Gender | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        includeAnonymous?: boolean | null,
        includePatients?: boolean | null,
        hasActiveRiskGroup?: boolean | null,
        caseStatuses?: Array<PersonCaseStatus> | null,
    ): CancelablePromise<GetInstitutionPersonListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institution/persons',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'gender': gender,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'includeAnonymous': includeAnonymous,
                'includePatients': includePatients,
                'hasActiveRiskGroup': hasActiveRiskGroup,
                'caseStatuses': caseStatuses,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Search a person in system by IDNP
     * Search a person in system by IDNP
     * @param idnp
     * @param shouldSearchInMConnect
     * @returns GetPersonByIdnpResponse The paginated list of transfer requests.
     * @throws ApiError
     */
    public static getPersonByIdnpEndpoint(
        idnp: string,
        shouldSearchInMConnect?: boolean | null,
    ): CancelablePromise<GetPersonByIdnpResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/by-idnp/{idnp}',
            path: {
                'idnp': idnp,
            },
            query: {
                'shouldSearchInMConnect': shouldSearchInMConnect,
            },
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized.`,
                403: `User is not allowed to search.`,
                404: `A person with this Idnp not found.`,
            },
        });
    }
    /**
     * Search a person in system by Id
     * Search a person in system by Id
     * @param id
     * @returns GetPersonByIdResponse Successfully found person.
     * @throws ApiError
     */
    public static getPersonByIdEndpoint(
        id: string,
    ): CancelablePromise<GetPersonByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed to search.`,
                404: `A person with this Id not found.`,
            },
        });
    }
    /**
     * Update a person in the system.
     * Update an existing person's details in the system using the UpdatePersonEndpoint.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updatePersonEndpoint(
        id: string,
        requestBody: UpdatePersonRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided input is invalid or missing required fields.`,
                401: `Unauthorized`,
                403: `The user is not authorized to update this person.`,
                404: `The specified person could not be found in the system.`,
            },
        });
    }
    /**
     * [Test] Permanently Delete a person from system
     * [Test] Permanently Delete a person to the system using the DeletePersonEndpoint
     * @param id
     * @returns any Success
     * @throws ApiError
     */
    public static deletePersonEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/persons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Search and retrieve a list of persons in the system
     *
     * Search for persons in the system with advanced filtering and sorting options:
     * - **Gender**: Filter results by gender (e.g., Male, Female, -).
     * - **BirthDateFrom**: Include persons born on or after this date.
     * - **BirthDateTo**: Include persons born on or before this date.
     * - **MonitoringFilter**:
     * - `None`: Search all persons.
     * - `Institution`: Filter by the monitoring institution linked to the current user.
     * - `InstitutionUserAssignment`: Filter by the monitoring institution and check if the user is assigned.
     * - **SearchTerm**: Filter by SimeCode, TarvCode, IDNP, FirstName, or LastName.
     * - **SortBy**: Specify the field to sort results by (e.g., SimeCode, TarvCode, IDNP, FirstName, LastName).
     * - **SortDirection**: Indicate sorting order.
     * - **PageNumber**: Specify the page number for pagination (default: 1).
     * - **PageSize**: Specify the number of records per page (default: 10, maximum: 100).
     *
     * @param pageNumber
     * @param pageSize
     * @param gender
     * @param birthDateFrom
     * @param birthDateTo
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param includeAnonymous
     * @param includePatients
     * @param hasActiveRiskGroup
     * @param caseStatuses
     * @returns GetAnonymousPersonListResponse The list has been found.
     * @throws ApiError
     */
    public static getAnonymousPersonListEndpoint(
        pageNumber: number,
        pageSize: number,
        gender?: Gender | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        includeAnonymous?: boolean | null,
        includePatients?: boolean | null,
        hasActiveRiskGroup?: boolean | null,
        caseStatuses?: Array<PersonCaseStatus> | null,
    ): CancelablePromise<GetAnonymousPersonListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/anonymous',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'gender': gender,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'includeAnonymous': includeAnonymous,
                'includePatients': includePatients,
                'hasActiveRiskGroup': hasActiveRiskGroup,
                'caseStatuses': caseStatuses,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get person for current user
     * Get person for current user, if this user is created based on person
     * @returns GetPersonResponse Successfully found person.
     * @throws ApiError
     */
    public static getPersonEndpoint(): CancelablePromise<GetPersonResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/person',
            errors: {
                400: `Validation failed.`,
                401: `The user is not authorized to perform this action.`,
                403: `User is not allowed.`,
                404: `A person not found.`,
            },
        });
    }
    /**
     * Update a person's guardianship status
     * This endpoint allows you to update the guardianship status of a person or establish a guardianship relationship.
     *
     * - If `Status` is set to `IsGuardian`, the person becomes a guardian.
     * - If `Status` is set to `UnderGuardianship`, the person is placed under guardianship.
     * - If `Status` is set to `NoGuardianRequired`, the person's guardianship status is updated to `NoGuardianship`.
     *
     * The `PersonId` and `Status` fields are required, and both must be valid. Additionally:
     * - `PersonId` must be a valid GUID.
     * @param personId
     * @param requestBody
     * @returns any Successfully updated the guardianship status.
     * @throws ApiError
     */
    public static updateGuardianshipStatusEndpoint(
        personId: string,
        requestBody: UpdateGuardianshipStatusRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/{personId}/guardianship-status',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters (PersonId, Status) were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Update guardianship media files.
     * This endpoint allows to update media files associated with a specific Guardianship.
     * You must specify the `GuardianshipId` and provide a list of media file IDs under `MediaItems`.
     * The `GuardianshipId` should be a valid GUID, and each `MediaItem` ID must also be a valid GUID.
     * @param guardianshipId
     * @param requestBody
     * @returns any Successfully added media files for the guardianship.
     * @throws ApiError
     */
    public static updateGuardianshipMediaFilesEndpoint(
        guardianshipId: string,
        requestBody: UpdateGuardianshipMediaFilesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/persons/guardianships/{guardianshipId}/media-files',
            path: {
                'guardianshipId': guardianshipId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided, are invalid, or conflict with existing records.`,
                401: `The user is not authorized to perform this action.`,
            },
        });
    }
    /**
     * Retrieve a list of guardianship relationships based on the specified guardianship status.
     * This endpoint retrieves guardianship relationships for a specific person based on their guardianship status.
     * You must provide the `PersonId` as a valid GUID.
     *
     * The `GuardianshipStatus` determines the type of relationships returned:
     * - `NoGuardianRequired`: The person does not require a guardian, and the `Guardianships` list will be empty.
     * - `UnderGuardianship`: The person is under guardianship, and the `Guardianships` list will contain their guardians.
     * - `IsGuardian`: The person is a guardian, and the `Guardianships` list will contain their wards (those under their guardianship).
     *
     * The response will provide the guardianship relationships corresponding to the specified status.
     * @param personId
     * @returns GetGuardianshipListResponse Successfully retrieved the list of guardianship relationships based on the specified status.
     * @throws ApiError
     */
    public static getGuardianshipListEndpoint(
        personId: string,
    ): CancelablePromise<GetGuardianshipListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/guardianships',
            path: {
                'personId': personId,
            },
            errors: {
                400: `The provided parameters (e.g., \`PersonId\` ) are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `No person found with given ID.`,
            },
        });
    }
    /**
     * Retrieve details of a guardianship relationship between a guardian and a ward.
     * This endpoint retrieves the details of a guardianship relationship where a guardian is assigned to a ward.
     * You must specify the `Id` of the guardianship to fetch the relevant details.
     * The `Id` should be a valid GUID representing the guardianship.
     * @param id
     * @returns GetGuardianshipResponse Successfully retrieved the guardianship details.
     * @throws ApiError
     */
    public static getGuardianshipEndpoint(
        id: string,
    ): CancelablePromise<GetGuardianshipResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/guardianships/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
                404: `The specified guardianship could not be found.`,
            },
        });
    }
    /**
     * Permanently delete guardianship relation
     * Permanently delete guardianship relation from the system using the DeleteGuardianshipEndpoint
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteGuardianshipEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/persons/guardianships/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation failed.`,
                401: `User is not authorized to perform this action.`,
                403: `User don't have access to delete.`,
                404: `A guardianship with this id does not exists.`,
            },
        });
    }
    /**
     * Add a ward to person.
     * This endpoint allows the creation of a guardianship relationship where a ward is assigned to a Person.
     * You can specify the `WardId` and `PersonId` to establish the guardianship relationship.
     * The request requires both IDs to be valid GUIDs, and they should not be equal.
     * @param personId
     * @param requestBody
     * @returns AddWardResponse Successfully created the guardianship.
     * @throws ApiError
     */
    public static addWardEndpoint(
        personId: string,
        requestBody: AddWardRequest,
    ): CancelablePromise<AddWardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/{personId}/wards',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters (WardId, PersonId) were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Add a guardian to person.
     * This endpoint allows the creation of a guardianship relationship where a guardian is assigned to a Person.
     * You can specify the `GuardianId` and `PersonId` to establish the guardianship relationship.
     * The request requires both IDs to be valid GUIDs, and they should not be equal.
     * @param personId
     * @param requestBody
     * @returns AddGuardianResponse Successfully created the guardianship.
     * @throws ApiError
     */
    public static addGuardianEndpoint(
        personId: string,
        requestBody: AddGuardianRequest,
    ): CancelablePromise<AddGuardianResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/{personId}/guardians',
            path: {
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters (GuardianId, PersonId) were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Notify new person case from external source.
     * This endpoint will be used by external service to report new case for person and inform institution  that monitoring locality of person.
     * @param requestBody
     * @returns NotifyNewCaseResponse Successfully notified person case.
     * @throws ApiError
     */
    public static notifyNewCaseEndpoint(
        requestBody: NotifyNewCaseRequest,
    ): CancelablePromise<NotifyNewCaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/persons/external/new-case',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
                409: `A person with this IDNP already exists.`,
            },
        });
    }
    /**
     * Add a anonymous person in system.
     * Add a anonymous person to the system using the CreatePersonEndpoint.
     * @param requestBody
     * @returns AddGuardianResponse Successfully created anonymous person.
     * @throws ApiError
     */
    public static createAnonymousPersonEndpoint(
        requestBody: CreateAnonymousPersonRequest,
    ): CancelablePromise<AddGuardianResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/person/anonymous',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `User is not authorized to perform this action.`,
                403: `Forbidden`,
                409: `A person with this IDNP already exists.`,
            },
        });
    }
}
